import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material'; 
import { Lote } from 'src/app/models/lote';
import { Movimientopago } from 'src/app/models/movimientopgo';
import { MovimientospgosService } from 'src/app/services/movimientospgos.service';
import { LotesdialogComponent } from '../lotesdialog/lotesdialog.component';

@Component({
  selector: 'app-inventariodialog',
  templateUrl: './inventariodialog.component.html',
  styleUrls: ['./inventariodialog.component.css']
})
export class InventariodialogComponent implements OnInit {


  listamov: Movimientopago[] = [];
  unsusmovimientos: any;
  idempresa: string;
  filtroPost = '';
  
  constructor(
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<InventariodialogComponent>,
    private movimientopgoService: MovimientospgosService,
    
  ) { }

  ngOnInit() {
    this.idempresa = this.data.identificador.idempresa._id;
    console.log ('esta es el di empresa',this.idempresa);
    this.listadomovimientos();
  }

  muestralotes(seleccionainventario : Lote){
   
    const dialogRef = this.dialog.open(LotesdialogComponent, {panelClass: 'mensaje',
      disableClose: true,
      data: {
         identificador: seleccionainventario
      }
    });

    dialogRef.afterClosed().subscribe(
      data => {
        // this.unsususuarios = this.usuariosptesAceptacion();
      }
    );
  }


  muestralotesExcursion(){
   
    const dialogRef = this.dialog.open(LotesdialogComponent, {panelClass: 'mensaje',
      disableClose: true,
      data: {
        // identificador: seleccionainventario
      }
    });

    dialogRef.afterClosed().subscribe(
      data => {
        // this.unsususuarios = this.usuariosptesAceptacion();
      }
    );
  }

  
  listadomovimientos() {
    this.unsusmovimientos =this.movimientopgoService.muestralistadolotesprecompra(this.idempresa)
      .subscribe(resp => {
       console.log (resp.movimiento);
        this.listamov = resp.movimiento;

      });
  }

  closeDialog() {
    this.dialogRef.close();
  
    }






    
 


}
